import { Locales } from "@/lib/i18n";
import { authSegments } from "@/locales/auth-segments";

export const segments: {
  [locale in Locales]: {
    [segment: string]: string;
  };
} = {
  nl: {
    inspiration_archive: "inspiraties",
    inspiration: "inspiraties", // Used for language switcher due to Prismic type
    single_inspiration: "inspiratie", // Used for language switcher due to Prismic type
    categories: "categorieen",
    product: "producten",
    login: authSegments.login.nl,
    account: "rekening",
    tables: "tafels",
    archive_table: "tafels",
    about: "volgende",
    catalogue: "catalogus",
    faq: "faq",
    cart: "winkelwagen",
    tag: "tag",
    checkout: "afrekenen",
    search: "zoekopdracht",
    contact: "contact",
    signup: authSegments.signup.nl,
    "forgot-password": authSegments["forgot-password"].nl,
    "reset-password": authSegments["reset-password"].nl,
  },
  fr: {
    inspiration_archive: "inspirations",
    single_inspiration: "inspiration", // Used for language switcher due to Prismic type
    inspiration: "inspirations", // Used for language switcher due to Prismic type
    categories: "categories",
    product: "produits",
    login: authSegments.login.fr,
    account: "compte",
    tables: "tables",
    archive_table: "tables",
    about: "a-propos",
    catalogue: "catalogue",
    faq: "faq",
    cart: "panier",
    tag: "tag",
    checkout: "commande",
    search: "recherche",
    contact: "contact",
    signup: authSegments.signup.fr,
    "forgot-password": authSegments["forgot-password"].fr,
    "reset-password": authSegments["reset-password"].fr,
  },
  en: {
    inspiration_archive: "inspirations",
    inspiration: "inspirations", // Used for language switcher due to Prismic type
    single_inspiration: "inspiration", // Used for language switcher due to Prismic type
    categories: "categories",
    product: "products",
    login: authSegments.login.en,
    account: "account",
    tables: "tables",
    archive_table: "tables",
    about: "about",
    catalogue: "catalogue",
    faq: "faq",
    cart: "cart",
    tag: "tag",
    checkout: "checkout",
    search: "search",
    contact: "contact",
    signup: authSegments.signup.en,
    "forgot-password": authSegments["forgot-password"].en,
    "reset-password": authSegments["reset-password"].en,
  },
};

export const actions: {
  [locale in Locales]: {
    [segment: string]: string;
  };
} = {
  fr: {
    address: "adresse",
    orders: "commandes",
    wishlist: "mes-favoris",
    business: "entreprise",
    edit: "modifier",
    "event-info": "informations-evenement",
    "customer-info": "informations-client",
    delivery: "livraison",
    recap: "resume",
    "thank-you": "merci",
    verify: "verifier",
    confirm: "confirmer",
  },
  nl: {
    address: "adres",
    orders: "bestellingen",
    wishlist: "mijn-favorieten",
    business: "bedrijf",
    edit: "bewerken",
    "event-info": "evenement-info",
    "customer-info": "klant-info",
    delivery: "levering",
    recap: "samenvatting",
    "thank-you": "bedankt",
    verify: "verifiëren",
    confirm: "bevestigen",
  },
  en: {
    address: "address",
    orders: "orders",
    wishlist: "wishlist",
    business: "business",
    edit: "edit",
    "event-info": "event-info",
    "customer-info": "customer-info",
    delivery: "delivery",
    recap: "recap",
    "thank-you": "thank-you",
    verify: "verify",
    confirm: "confirm",
  },
};
